var toList = function (array) {
    if (array.length === 0)
        return array;
    var items = array.filter(function (item) { return !!item; }).map(function (item) { return "- ".concat(item); });
    return items.join('\n');
};

export { toList };
//# sourceMappingURL=toList.esm.js.map
